<template>
  <!-- 导航开始 -->
  <div class='commonClientinfoSavezhuangtai'>
    <hr>
    <div class="row">
      <div class="col-6">
        <multiselect v-model="businessVal" track-by="name" label="name" placeholder="客户类型 - 必选" :options="businessArr" :searchable="false"  :show-labels="false">
          <template slot="singleLabel" slot-scope="{ option }">{{ option.name }}</template>
        </multiselect>
        <br>
      </div>
      <div class="col-6">
        <multiselect v-model="sourceVal" track-by="name" label="name" placeholder="客户来源 - 必选" :options="sourceArr" :searchable="false"  :show-labels="false">
          <template slot="singleLabel" slot-scope="{ option }">{{ option.name }}</template>
        </multiselect>
        <br>
      </div>
      <div class="col-6">
        <multiselect v-model="statusVal" track-by="name" label="name" placeholder="客户状态 - 必选" :options="statusArr" :searchable="false"  :show-labels="false">
          <template slot="singleLabel" slot-scope="{ option }">{{ option.name }}</template>
        </multiselect>
      </div>
      <div class="col-6">
        <multiselect v-model="levelVal" track-by="name" label="name" placeholder="客户等级" :options="levelArr" :searchable="false"  :show-labels="false">
          <template slot="singleLabel" slot-scope="{ option }">{{ option.name }}</template>
        </multiselect>
      </div>
      <div class="col-12" v-if="info.type!=='1' && info.is_del!=='1'">
        <hr>
        <button @click="saveZhuangtai" type="button" class="btn btn-success btn-round">修改</button>
        <button @click="qiehuanZhuangtai('ui-client-info-trace')" type="button" class="btn btn-light btn-round">取消</button>
      </div>
    </div>
    <div class="searchLoadingBox" v-if="isSearchLoading">
      <span>
        <i class='iconfont icon-jiazai xuanzhuan'></i>
      </span>
    </div>
  </div>
  <!-- 导航结束 -->
</template>

<script>
import rbacMix from '@/util/mix/localUserMix';
import resultCommons from '@/util/resultcommons';
import { EventBus } from '@/util/eventBus';
import Multiselect from 'vue-multiselect';
import 'vue-multiselect/dist/vue-multiselect.min.css';
import commons from '../../../util/commons';

export default {
  name: 'commonClientinfoSavezhuangtai',
  props: ['token', 'pInitDataInfo', 'info', 'rootUnitIsSuccessFun', 'isDelFun', 'qiehuanZhuangtai'],
  mixins: [rbacMix],
  data() {
    return {
      // 加载中
      isSearchLoading: true,

      // 客户类型
      businessVal: null,
      // 来源
      sourceVal: null,
      // 客户类型
      statusVal: null,
      // 客户类型
      levelVal: null,
      // 来源
      sourceArr: [
        { name: '渠道介绍', id: '1' },
      ],
      // 类型
      businessArr: [
        { name: '移民', id: '1' },
      ],
      // 状态
      statusArr: [
        { name: '有效', id: '1' },
      ],
      // 等级
      levelArr: [
        { name: '一般客户', id: '1' },
      ],
    };
  },
  computed: {
    dataJson() {
      return {
        token: this.info.id,
        business_id: commons.whereArrStr(this.businessVal),
        source_id: commons.whereArrStr(this.sourceVal),
        duty_status: commons.whereArrStr(this.statusVal),
        duty_level: commons.whereArrStr(this.levelVal),
      };
    },
  },
  methods: {
    // 获取标签
    apiCrmTages() {
      // 获取的类型(状态/等级)
      const root = this.info.type === '2' ? 2 : 5;
      console.log(root);
      return resultCommons.apiCrmTages(this, { root, city: true }).then((ob) => {
        this.businessArr = ob.data.leixing;
        this.sourceArr = ob.data.laiyuan;
        this.statusArr = ob.data.zhuangtai;
        this.levelArr = ob.data.dengji;
      });
    },
    setInitDataInfo() {
      // 等级
      this.levelVal = { id: this.info.duty_level, name: this.info.duty_level_title };
      // 状态
      this.statusVal = { id: this.info.duty_status, name: this.info.duty_status_title };
      // 来源
      this.sourceVal = { id: this.info.source_id, name: this.info.source_id_title };
      // 类型
      this.businessVal = { id: this.info.business_id, name: this.info.business_id_title };
    },
    saveZhuangtai() {
      this.isSearchLoading = true;
      resultCommons.apiCrmsavezhuangtai(this, this.dataJson).then((app) => {
        if (app.state === 200) {
          // 同步父级基本信息
          this.pInitDataInfo().then((app) => {});
          this.rootUnitIsSuccessFun(3, app.data.dataArrStr);
          this.qiehuanZhuangtai('ui-client-info-trace');
        } else {
          this.$message.showMsgBox({
            type: 'warning',
            content: app.message,
          });
        }
        this.isSearchLoading = false;
      });
    },
  },
  components: {
    Multiselect,
  },
  created() {
    // 标签
    this.apiCrmTages().then((app) => {
      this.isSearchLoading = false;
    });
    this.setInitDataInfo();
  },
  mounted() {
  },
  destroyed() {
  },
};
</script>

<style scoped lang='less'>
.commonClientinfoSavezhuangtai{
  flex: 1;
  overflow-y: auto;
  background: #F6F6F6;
  padding: 15px;
}
</style>



// WEBPACK FOOTER //
// src/components/common/clientinfo/savezhuangtai.vue